// PageDescription: 커뮤니티 상세 페이지
import { QueryClient, dehydrate } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';

import PostDetailTemplate from '@/components/templates/mobile/communication/Community/PostDetailTemplate';
import { useGetBoardPostQuery } from '@/hooks/community/mobile/community.gql.impl';
import { GraphqlError, ServerError } from '@/types/error';

interface Props {
  boardPostPid: string;
  userAgent: string;
}

const PostDetailPage = ({ boardPostPid, userAgent }: Props) => {
  return <PostDetailTemplate boardPostPid={boardPostPid} userAgent={userAgent} />;
};

export default PostDetailPage;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const queryClient = new QueryClient();
  const id = ctx.params?.id as string;

  if (!id) {
    return {
      redirect: {
        destination: '/content/board',
        permanent: false,
      },
    };
  }
  const params = {
    boardPostPid: id,
  };
  try {
    await queryClient.fetchQuery(['getBoardPost', params], useGetBoardPostQuery.fetcher(params));
  } catch (e) {
    const { code } = e as unknown as GraphqlError;
    if (code === ServerError.NotFound) {
      return {
        notFound: true,
      };
    }
    if (ctx.res && code === ServerError.BadRequest) {
      ctx.res.statusCode = 400;
    }

    return {
      notFound: true,
    };
  }

  return {
    props: {
      boardPostPid: id,
      dehydratedState: dehydrate(queryClient),
    },
  };
};
